export default __webpack_public_path__ + "static/media/JensenLakesCrossingMontage.5fb3d54a.jpg";